import { forwardRef } from 'react';
import { Icon } from '../../../UI';
import styles from './Search.module.scss';

interface ISearch {
  placeholder?: string;
  className?: string;
  value?: string;
  changeValue?: (value?: string) => void;
}

const Search = forwardRef<HTMLInputElement, ISearch>(({
  placeholder = 'Buscar na Coordly',
  className = '',
  value = '',
  changeValue
}, ref) => {

  return (
    <div className={`${styles['Search']} ${className}`}>
      <Icon
        icon='buscar'
        customSize={18}
        color='cinzaSuperior'
        className={styles['icon']}
      />
      <input
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={(event: any) => changeValue && changeValue(event.currentTarget.value)}
      />
    </div>
  );
});

export default Search;
